import gql from 'graphql-tag';

export class FormInput {
  id: number;
  legacyAppId: string;
  name: string;
  notes: string;
  phone: string;
  collectorId: number;
  userId: number;
  adrNumber: string;
  adrExpDate: Date;
  adrFileId: number;
  licenseExpDate: Date;
  licenseFileId: number;
  signFileId: number;
  isActive: boolean;
  isApproved: boolean;
  approvedBy: string;
  approvedDate: Date;
  vehicleId: number;

  constructor() {
    this.id = undefined;
    this.legacyAppId = undefined;
    this.name = undefined;
    this.notes = undefined;
    this.phone = undefined;
    this.collectorId = undefined;
    this.userId = undefined;
    this.adrNumber = undefined;
    this.adrExpDate = undefined;
    this.adrFileId = undefined;
    this.licenseExpDate = undefined;
    this.licenseFileId = undefined;
    this.signFileId = undefined;
    this.isActive = undefined;
    this.isApproved = undefined;
    this.approvedBy = undefined;
    this.approvedDate = undefined;
    this.vehicleId = undefined;
  }
}

//τεστ

export const gqlGetQuery = gql`
  query getDrivers($limit: Int, $offset: Int, $order: String, $where: String) {
    getDrivers(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        legacyAppId
        name
        notes
        phone
        collectorId
        collector {
          id
          name
        }
        userId
        user {
          id
          userName
        }
        adrNumber
        adrExpDate
        adrFileId
        adrFilesrepository {
          id
          fileName
          mimeMediaType
          s3Key
        }
        licenseExpDate
        licenseFileId
        licenseFilesrepository {
          id
          fileName
          mimeMediaType
          s3Key
        }
        signFileId
        signFilesrepository {
          id
          fileName
          mimeMediaType
          s3Key
        }
        isApproved
        approvedBy
        approvedDate
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getDriverById($id: Int) {
    getDriverById(id: $id) {
      id
      legacyAppId
      name
      notes
      phone
      collectorId
      collector {
        id
        name
      }
      userId
      user {
        id
        userName
      }
      vehicleId
      vehicle {
        id
        plateNumber
      }
      adrNumber
      adrExpDate
      adrFileId
      adrFilesrepository {
        id
        fileName
        mimeMediaType
        s3Key
      }
      licenseExpDate
      licenseFileId
      licenseFilesrepository {
        id
        fileName
        mimeMediaType
        s3Key
      }
      signFileId
      signFilesrepository {
        id
        fileName
        mimeMediaType
        s3Key
      }
      isApproved
      approvedBy
      approvedDate
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      # collectorMaterials {
      #   id
      #   collectorId
      #   materialId
      #   material {
      #     id
      #     name
      #   }
      # }
    }
  }
`;

export const gqlAdd = gql`
  mutation addDriver($data: DriverInput) {
    addDriver(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateDriver($data: DriverInput) {
    updateDriver(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteDriver($id: Int) {
    deleteDriver(id: $id)
  }
`;

export const gqlAccept = gql`
  mutation acceptDriver($id: Int) {
    acceptDriver(id: $id)
  }
`;
